import { render, staticRenderFns } from "./MessageV2.vue?vue&type=template&id=57b1d4a3&scoped=true"
import script from "./MessageV2.vue?vue&type=script&lang=js"
export * from "./MessageV2.vue?vue&type=script&lang=js"
import style0 from "./MessageV2.vue?vue&type=style&index=0&id=57b1d4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b1d4a3",
  null
  
)

export default component.exports